/*
------------------------------------------------------------------------------------
ローカルストレージ内で単元毎にあるObj配列「saveAry」を初期化
------------------------------------------------------------------------------------
*/

function resetSaveObj(jsonObj_qAry) {
	var saveAry = [];
	for (var i = 0; i < jsonObj_qAry.length; i++) {
		const id = jsonObj_qAry[i].head_id;
		saveAry[id] = {
			head_id: id, // 単元ID
			header: jsonObj_qAry[id].header, // 単元見出し
			current_gid: 0, // タイトル内のグローバルID
			lastVisitedPage: 'general', // 単元毎の現在解答番号
			current: 0, // 単元毎の現在解答番号
			index: 0, // 単元毎の出題通し番号（シャッフル出題用）
			cache: {q: 0, a: 0}, // 単元毎のキャッシュ用合計解答数（q）と合計正解数（a）
			total: {q: 0, a: 0}, // 単元毎の現在までの累計解答数（q）と累計正解数（a）
			finishBool: false, // 単元毎で一通り解答完了したかの論理値
			percent: 0, // 単元毎の現在までの累計正解率
			randomAry: [], // 単元毎のシャッフル配列 {id: 0, random: 0}
			bookmarkAry: [], // 単元毎の問題登録配列 {id: 0, bool: 0}
			correctAry: [], // 単元毎の問題登録配列 {id: 0, bool: 0},
			fixed : [],
			multiple: []
		};
	}

	return saveAry;
}
export default {resetSaveObj}